module.exports = __webpack_public_path__ + "img/logo-arica.8bc0d361.png";